import React from 'react';

export const changeDescription = (
  <div>
    <h3 className="vads-u-font-size--h5">Changes in social behavior</h3>
    <p>
      Please tell us about any changes in your social life as a result the
      event. You may have experienced some or none of these. (Please check any
      that apply.)
    </p>
  </div>
);
